import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import './ArcadeModal.css';
import './GamePicker.css';

// Fuente única del menú de juegos. `id` debe coincidir con handleGameSelect en AppShell.
// `gradient` es la "portada" de cada juego (estilo minijuegos) y `tag` su categoría.
const GAMES = [
  {
    id: 'minesweeper',
    name: 'BuscaMinis',
    emoji: '💣',
    desc: 'Encuentra las VACWAYminis ocultas en el tablero',
    tag: 'Puzzle',
    gradient: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
  },
  {
    id: 'flappybird',
    name: 'Flappy Locker',
    emoji: '🐦',
    desc: 'Vuela entre las taquillas sin chocar',
    tag: 'Arcade',
    gradient: 'linear-gradient(135deg, #22c55e, #15803d)',
  },
  {
    id: 'snake',
    name: 'Snake Locker',
    emoji: '🐍',
    desc: 'Come taquillas mini y crece sin chocar',
    tag: 'Clásico',
    gradient: 'linear-gradient(135deg, #14b8a6, #0d9488)',
  },
];

const GamePicker = ({ isOpen, onSelect, onClose }) => {
  return (
    <Modal isOpen={isOpen} toggle={onClose} centered className="gp-dialog" contentClassName="arcade-modal">
      <ModalHeader toggle={onClose} className="arcade-header" tag="div">
        <span className="arcade-title">
          <span className="arcade-icon"><i className="fas fa-gamepad"></i></span>
          Arcade
        </span>
      </ModalHeader>

      <ModalBody className="arcade-body">
        <p className="gp-subtitle">Elige un juego para echar una partida</p>
        <div className="gp-grid">
          {GAMES.map((game) => (
            <button key={game.id} className="gp-card" onClick={() => onSelect(game.id)}>
              <div className="gp-cover" style={{ background: game.gradient }}>
                <span className="gp-emoji">{game.emoji}</span>
                <span className="gp-tag">{game.tag}</span>
                <span className="gp-play"><i className="fas fa-play"></i></span>
              </div>
              <div className="gp-info">
                <div className="gp-name">{game.name}</div>
                <div className="gp-desc">{game.desc}</div>
                <span className="gp-btn">Jugar <i className="fas fa-arrow-right"></i></span>
              </div>
            </button>
          ))}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default GamePicker;
